import { Link } from "react-router-dom";
import { categories } from "@/mocks/categories";

export default function CategorySection() {
  return (
    <section className="mx-auto w-full max-w-[1400px] px-4 py-14 md:px-6 md:py-20">
      <div className="flex flex-wrap items-end justify-between gap-4">
        <div>
          <h2 className="flex items-center gap-2 font-heading text-2xl font-bold text-foreground-50 md:text-3xl">
            <i className="ri-focus-2-line text-primary-400" aria-hidden="true"></i>
            主题分类
          </h2>
          <p className="mt-2 text-sm text-foreground-500">
            按你的推理口味，快速找到想追更的作品
          </p>
        </div>
        <p className="hidden text-xs text-foreground-600 sm:block">
          6 大分类 · 覆盖多种烧脑类型
        </p>
      </div>

      <div className="mt-8 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
        {categories.map((c, i) => (
          <Link
            key={c.slug}
            to={`/category/${c.slug}`}
            className="group relative overflow-hidden rounded-lg border border-background-200/60 bg-background-100 p-5 transition-colors hover:border-accent-300/50 md:p-6"
          >
            <span className="absolute right-4 top-4 font-heading text-4xl font-black text-background-200 transition-colors group-hover:text-accent-500/20">
              0{i + 1}
            </span>
            <span className="flex h-11 w-11 items-center justify-center rounded-md bg-primary-500/15 text-primary-400 transition-colors group-hover:bg-primary-500/30">
              <i className={`${c.icon} text-xl`} aria-hidden="true"></i>
            </span>
            <h3 className="mt-4 font-heading text-lg font-bold text-foreground-100">
              {c.name}漫画
              <span className="ml-2 text-xs font-normal text-foreground-500">
                {c.en}
              </span>
            </h3>
            <p className="mt-2 text-sm leading-relaxed text-foreground-500">
              {c.desc}
            </p>
            <span className="mt-4 inline-flex items-center gap-1 text-xs font-medium text-accent-300 transition-transform group-hover:translate-x-1">
              {c.tagline}
              <i className="ri-arrow-right-line" aria-hidden="true"></i>
            </span>
          </Link>
        ))}
      </div>
    </section>
  );
}